import { z } from "zod"

export const richtextSchema = z.object({
  type: z.literal("doc"),
  content: z.array(z.object({ type: z.any(), attrs: z.any(), content: z.any() })),
})

export type SbRichText = z.infer<typeof richtextSchema>
